import { useState } from "react";

export const VolumeBlock = (props) => {
    const {audio} = props;

    const [value, setValue] = useState(10);

    const onChange = (e) => {
        setValue(e.target.value);
        audio.volume = value/10;
    }

    if (audio.volume == 0.1) {
        audio.volume = 0.3;
    }

    return (
        <div className="volume-block">
            <input type="range" min="1" max="10" value={value} onChange={onChange} />
        </div>
    );
}